module.exports = __webpack_public_path__ + "img/tencent-weibo.6e02fe3e.svg";